import { useTheme } from '@/features/theme-switch';
import { config } from '@/shared/lib';

// eslint-disable-next-line import/no-absolute-path
import logoAdplay from '/logo-adplay.svg?url';
// eslint-disable-next-line import/no-absolute-path
import logoDark from '/logo-dark.svg?url';
// eslint-disable-next-line import/no-absolute-path
import logo from '/logo-full.svg?url';

const LogoText = ({ className = '' }: { className?: string }) => {
  const { darkTheme } = useTheme();

  const domain = localStorage.getItem('token')
    ? `pub.${config.ROOT_DOMAIN}`
    : config.ROOT_DOMAIN;

  if (config.CONTENT_ONLY_BUILD) {
    return (
      <a href={`https://${domain}`} className={className}>
        <img
          style={{ width: '100%', height: '100%' }}
          src={logoAdplay}
          alt="logo"
        />
      </a>
    );
  }

  return (
    <a href={`https://${domain}`} className={className}>
      <img
        style={{ width: '100%', height: '100%' }}
        src={darkTheme ? logoDark : logo}
        alt="logo"
      />
    </a>
  );
};

export default LogoText;
